import { getCookie } from '@/common/utils/commonFunc'
import qs from 'query-string'
// BigC 电召登录参数
const qsObj = qs.parse(window.location.search)
export const bigC_login_data  = {
  type: 'logIn',
  data: {
    app_id: '835',
    ssoTicket: getCookie('ssoTicketForFE') || getCookie('ssoTicket'), 
    user_name: getCookie('user_name'),
    canonical_country_code: getCookie('canonical_country_code'), 
    lang: getCookie('lang'),
    ivrCityId: qsObj.ivrCityId,
    ivrPhone: qsObj.ivrPhone,
    ivrType: qsObj.ivrType,
    callid: qsObj.callid
  }
}

// 水印
// export const waterMarkConfig = {
//   watermark_txt: '835 '+ getCookie('user_name') + ' ' + water_date,  //水印的内容
//   watermark_fontsize:'24px',          //水印字体大小
//   watermark_x_space:100,              //水印x轴间隔
//   watermark_y_space:50,               //水印y轴间隔
//   watermark_alpha:0.05,               //水印透明度，要求设置在大于等于0.005
//   watermark_angle:330,                 //水印倾斜度数
//   watermark_width:350,                //水印宽度
//   watermark_height:100,               //水印长度
//   watermark_parent_node: document.getElementsByClassName('basic-layout')[0]
// }
export const waterMarkConfig = {
  systemId: '835',
  //当前用户ID
  userId: getCookie('user_name'),
  containerEl: null,
  textStyle:"rgba(0,0,0,0.05)"
}